import { render, staticRenderFns } from "./MenuView.vue?vue&type=template&id=9d2a5ca2&"
import script from "./MenuView.vue?vue&type=script&lang=js&"
export * from "./MenuView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports